import { createSelector } from 'reselect';

const getFavories = ({ favorites }) => favorites;

const getId = (_, { id }) => id;
const getType = (_, { type }) => type;

export const fetchFavorites = createSelector(
  [getFavories, getId, getType],
  (favorites, id, type) => {
    const { loaded, loading, ...rest } = favorites;
    const res = {
      loaded,
      loading
    };
    const favorite = (rest[type] || {})[id];
    if (favorite) {
      res.isAdded = true;
    }
    return res;
  }
);
